import { version } from './config';


export const buildMenu = ({ inventoryEnabled, nutritionAnalysis, schools }) => {
  const productionRecSchools = (schools || []).filter(sch => {
    return sch.moduleAccess["Production Record"] == "Yes";
  })
  const homeRoutes = {
    name: 'Home',
    to: '/dashboard',
    exact: true,
    icon: 'chart-pie'
  };
  const manageRoutes = {
    name: 'Manage',
    to: '/manage',
    icon: 'copy',
    children: [
      {
        name: 'Master Catalog',
        children: [
          { to: '/manage/products', id: 'products', name: 'Ingredients', isLink: true },
          { to: '/recipes/myRecipeCatalog', id: 'myRecipe', name: 'Recipes', isLink: true },
          { to: '/manage/masterItemsCatalog', id: 'masterItems', name: 'Master Items', isLink: true },
          { to: '/manage/importProducts', id: 'importProducts', name: 'Upload Products', isLink: true },
        ]
      },
      {
        name: 'Menus',
        children: [
          { to: '/manage/manageRollingMenus', id: "schoolMenus", name: 'Cycle Menus', isLink: true },
          { to: '/manage/manageMasterMenus', id: "masterMenus", name: 'Master Menus', isLink: true },
          { to: '/manage/manageSchoolMenus', id: "schoolMenus", name: 'School Menus', isLink: true }
        ]
      },

    ]
  }
  if (productionRecSchools.length > 0 || inventoryEnabled) {
    manageRoutes.children.push({
      name: 'Production',
      children: [
      ]
    });
  }
  if (productionRecSchools.length > 0) {
    manageRoutes.children.map(mItem => {
      if (mItem.name == "Production") {
        mItem.children.push({ to: '/manage/productionMenu', id: "productionRecords", name: 'Production Records', isLink: true })
      }
    });
  }
  if (inventoryEnabled) {
    manageRoutes.children.map(mItem => {
      if (mItem.name == "Production") {
        // Always show these inventory features when inventoryEnabled is true
        mItem.children.push({ to: "/manage/inventory/startingInventory", id: 'inventory', name: 'Starting Inventory', isLink: true });
        mItem.children.push({ to: '/manage/inventory', id: "inventory", name: 'Current Inventory', isLink: true });
        mItem.children.push({ to: '/manage/inventory/physicalInventory', id: 'inventory', name: "Physical Inventory", isLink: true });

        // Only show Inventory Transfer and Vendor Orders when both inventoryEnabled and nutritionAnalysis are true
        if (nutritionAnalysis) {
          mItem.children.push({ to: "/manage/inventory/inventoryTransfer", id: "inventoryTransfer", name: "Inventory Transfer", isLink: true });
          mItem.children.push({ to: "/manage/inventory/vendorOrders", id: "vendorOrders", name: "Vendor Orders", isLink: true });
        }
      }
    })
  }

  const settingsRoutes = {
    name: 'Settings',
    to: '/settings',
    children: [
      { to: '/settings/manageUsers', name: 'Manage Users', isLink: true },
      { to: '/settings/menuPlaceholders', name: 'Menu Placeholders', isLink: true },
      { to: '/settings/manageHolidays', name: 'Manage Holidays', isLink: true },
      { to: '/settings/vendors', name: 'Vendors', isLink: true },
      { to: '/settings/storageLocations', name: 'Storage Locations', isLink: true }
    ]
  }
  if (inventoryEnabled) {
    settingsRoutes.children.push({ to: '/settings/inventorySiteList', name: 'Inventory Site List', isLink: true })
  }
  if (nutritionAnalysis) {
    settingsRoutes.children.push({ to: '/settings/nutritionAnalysisSettings', name: 'Nutrition Analysis Settings', isLink: true })

  }
  const reportRoutes = {
    name: 'Reports',
    to: '/reports',
    children: [
    ]
  }
  if (!nutritionAnalysis) {
    reportRoutes.children.push({
      name: '',
      children: [
        { to: '/reports/ordersDetails', name: 'Meal Report', isLink: true },
        { to: '/reports/depositReport', name: 'Deposits Report', isLink: true },
        { to: '/reports/salesReport', name: 'Sales Report', isLink: true }
      ]
    })
  }

  if (inventoryEnabled) {
    const inventoryReports = [
      /*  { to: '/reports/currentInventory', name: "Current Inventory", isLink: true },
       { to: '/reports/menuCostingReport', name: "Menu Costing Report", isLink: true }, */
      { to: '/reports/inventoryItemsReport', name: "Inventory Items", isLink: true },
      // { to: '/reports/inventoryPurchaseOrder', name: "Inventory Purchase Order", isLink: true },
      // { to: '/reports/inventoryPurchaseOrderShopping', name: "Shopping List", isLink: true },
      { to: '/reports/inventoryVarianceReport', name: "Variance Report", isLink: true },
    ];

    // Only show Receipt Order Transfer History when both inventoryEnabled and nutritionAnalysis are true
    if (nutritionAnalysis) {
      inventoryReports.push({ to: '/reports/ReceiptOrderTransferHistoryReport', name: "Receipt Order Transfer History", isLink: true });
    }

    inventoryReports.push({ to: '/reports/PhysicalInventorySummaryReport', name: "Physical Inventory Summary", isLink: true });

    reportRoutes.children.push({
      name: 'Inventory',
      children: inventoryReports
    });
  }
  if (nutritionAnalysis) {
    reportRoutes.children.unshift(
      {
        name: 'Nutritions',
        children: [
          { to: '/reports/nutrionsCompositionReport', name: "Composition Report", isLink: true },
          { to: '/reports/nutritionAnalysisReport', name: "Analysis Report", isLink: true },
          { to: '/reports/mealpatternReport', name: "Meal Pattern Report", isLink: true },
          { to: '/reports/nutStandardReport', name: 'Nutrient Standard Report', isLink: true },
          { to: '/reports/mealPatternStandardsReport', name: 'Meal Pattern Standards Report', isLink: true },
          { to: '/reports/missingNutritionReport', name: 'Missing Nutrition Report', isLink: true },
          { to: '/reports/discontinuedItemsReport', name: 'Discontinued Items Report', isLink: true },
          { to: '/reports/productionRecordReport', name: 'Production Record Report', isLink: true }
        ]
      }
    );
  }
  return [homeRoutes, manageRoutes, reportRoutes, settingsRoutes]

}

export const homeRoutes = {
  name: 'Home',
  to: '/',
  exact: true,
  icon: 'chart-pie'
};

export const authenticationRoutes = {
  name: 'Authentication',
  to: '/authentication',
  icon: 'lock',
  children: [
    {
      to: '/authentication/basic',
      name: 'Basic',
      children: [
        { to: '/authentication/basic/login', name: 'Login' },
        { to: '/authentication/basic/logout', name: 'Logout' },
        { to: '/authentication/basic/register', name: 'Register' },
        { to: '/authentication/basic/forget-password', name: 'Forgot password' },
        { to: '/authentication/basic/password-reset', name: 'Reset password' },
        { to: '/authentication/basic/confirm-mail', name: 'Confirm mail' },
        { to: '/authentication/basic/lock-screen', name: 'Lock screen' }
      ]
    },
    {
      to: '/authentication/card',
      name: 'Card',
      children: [
        { to: '/authentication/card/login', name: 'Login' },
        { to: '/authentication/card/logout', name: 'Logout' },
        { to: '/authentication/card/register', name: 'Register' },
        { to: '/authentication/card/forget-password', name: 'Forgot password' },
        { to: '/authentication/card/password-reset', name: 'Reset password' },
        { to: '/authentication/card/confirm-mail', name: 'Confirm mail' },
        { to: '/authentication/card/lock-screen', name: 'Lock screen' }
      ]
    },
    {
      to: '/authentication/split',
      name: 'Split',
      children: [
        { to: '/authentication/split/login', name: 'Login' },
        { to: '/authentication/split/logout', name: 'Logout' },
        { to: '/authentication/split/register', name: 'Register' },
        { to: '/authentication/split/forget-password', name: 'Forgot password' },
        { to: '/authentication/split/password-reset', name: 'Reset password' },
        { to: '/authentication/split/confirm-mail', name: 'Confirm mail' },
        { to: '/authentication/split/lock-screen', name: 'Lock screen' }
      ]
    },
    {
      to: '/authentication/wizard',
      name: 'Wizard'
    }
  ]
};

export const ECommerceRoutes = {
  name: 'E commerce',
  to: '/e-commerce',
  icon: 'cart-plus',
  children: [
    { to: '/e-commerce/products/list', name: 'Product list' },
    { to: '/e-commerce/products/grid', name: 'Product grid' },
    { to: '/e-commerce/product-details', name: 'Product details' },
    { to: '/e-commerce/orders', name: 'Orders' },
    { to: '/e-commerce/order-details', name: 'Order details' },
    { to: '/e-commerce/customers', name: 'Customers' },
    { to: '/e-commerce/shopping-cart', name: 'Shopping cart' },
    { to: '/e-commerce/checkout', name: 'Checkout' },
    { to: '/e-commerce/favourite-items', name: 'Favourite items' }
  ]
};

export const pageRoutes = {
  name: 'Pages',
  to: '/pages',
  icon: 'copy',
  children: [
    { to: '/pages/activity', name: 'Activity' },
    { to: '/pages/associations', name: 'Associations' },
    { to: '/pages/billing', name: 'Billing' },
    { to: '/pages/customer-details', name: 'Customer details' },
    { to: '/pages/event-detail', name: 'Event detail' },
    { to: '/pages/event-create', name: 'Event create' },
    { to: '/pages/events', name: 'Events' },
    { to: '/pages/faq', name: 'Faq' },
    { to: '/pages/invoice', name: 'Invoice' },
    { to: '/pages/invite-people', name: 'Invite people' },
    { to: '/pages/notifications', name: 'Notifications' },
    { to: '/pages/people', name: 'People' },
    { to: '/pages/pricing', name: 'Pricing' },
    { to: '/pages/pricing-alt', name: 'Pricing alt' },
    { to: '/pages/profile', name: 'Profile' },
    { to: '/pages/settings', name: 'Settings' },
    { to: '/pages/starter', name: 'Starter' },
    {
      to: '/errors',
      name: 'Errors',
      children: [{ to: '/errors/404', name: '404' }, { to: '/errors/500', name: '500' }]
    }
  ]
};
export const widgetsRoutes = {
  name: 'Widgets',
  to: '/widgets',
  exact: true,
  icon: 'poll'
};

export const calenderRoutes = {
  name: 'Calendar',
  to: '/calendar',
  exact: true,
  icon: 'calendar-alt'
};

export const chatRoutes = {
  name: 'Chat',
  to: '/chat',
  exact: true,
  icon: 'comments'
};

export const kanbanRoutes = {
  name: 'Kanban',
  to: '/kanban',
  exact: true,
  icon: ['fab', 'trello']
};

export const emailRoutes = {
  name: 'Email',
  to: '/email',
  icon: 'envelope-open',
  children: [
    { to: '/email/inbox', name: 'Inbox' },
    { to: '/email/email-detail', name: 'Email detail' },
    { to: '/email/compose', name: 'Compose' }
  ]
};

export const documentationRoutes = {
  name: 'Documentation',
  to: '/documentation',
  exact: true,
  icon: 'book'
};

export const changelogRoutes = {
  name: 'ChangeLog',
  to: '/changelog',
  exact: true,
  icon: 'code-branch',
  badge: {
    text: `v${version}`,
    color: 'soft-primary'
  }
};

export const componentRoutes = {
  name: 'Components',
  to: '/components',
  icon: 'puzzle-piece',
  children: [
    { to: '/components/alerts', name: 'Alerts' },
    { to: '/components/accordions', name: 'Accordions' },
    {
      to: '/components/autocomplete',
      name: 'Autocomplete'
    },
    { to: '/components/avatar', name: 'Avatar' },
    { to: '/components/badges', name: 'Badges' },
    { to: '/components/backgrounds', name: 'Backgrounds' },
    { to: '/components/breadcrumb', name: 'Breadcrumb' },
    { to: '/components/buttons', name: 'Buttons' },
    { to: '/components/cards', name: 'Cards' },
    {
      to: '/components/cookie-notice',
      name: 'Cookie notice'
    },
    { to: '/components/collapses', name: 'Collapses' },
    {
      to: '/components/carousel',
      name: 'Carousel'
    },
    { to: '/components/dropdowns', name: 'Dropdowns' },
    { to: '/components/forms', name: 'Forms' },
    { to: '/components/listgroups', name: 'List groups' },
    { to: '/components/modals', name: 'Modals' },
    { to: '/components/navs', name: 'Navs' },
    {
      to: '/components',
      name: 'Navbar',
      children: [
        { to: '/components/navbars', name: 'Default' },
        {
          to: '/components/navbar-vertical',
          name: 'Vertical'
        },
        {
          to: '/components/navbar-top',
          name: 'Top'
        },
        {
          to: '/components/combo',
          name: 'Combo'
        }
      ]
    },
    { to: '/components/pageheaders', name: 'Page headers' },
    { to: '/components/paginations', name: 'Paginations' },
    { to: '/components/popovers', name: 'Popovers' },
    { to: '/components/progress', name: 'Progress' },
    { to: '/components/sidepanel', name: 'Sidepanel' },
    { to: '/components/spinners', name: 'Spinners' },
    {
      to: '/components/tab',
      name: 'Tabs',
      badge: {
        text: `New`,
        color: 'soft-success'
      }
    },
    { to: '/components/tables', name: 'Tables' },
    { to: '/components/tooltips', name: 'Tooltips' }
  ]
};

export const pluginRoutes = {
  name: 'Plugins',
  to: '/plugins',
  icon: 'plug',
  children: [
    { to: '/plugins/bulk-select', name: 'Bulk select' },
    {
      to: '/plugins/react-beautiful-dnd',
      name: 'Beautiful DnD'
    },
    {
      to: '/plugins',
      name: 'Chart',
      children: [{ to: '/plugins/chart', name: 'Chart Js' }, { to: '/plugins/echarts', name: 'Echarts' }]
    },
    { to: '/plugins/countup', name: 'Countup' },
    { to: '/plugins/code-highlight', name: 'Code Highlight' },
    { to: '/plugins/datetime', name: 'Datetime' },
    { to: '/plugins/dropzone', name: 'Dropzone' },
    { to: '/plugins/emoji-mart', name: 'Emoji Mart' },
    { to: '/plugins/font-awesome', name: 'Font Awesome' },
    {
      to: '/plugins/calendar-example',
      name: 'Full Calendar'
    },
    { to: '/plugins/image-lightbox', name: 'Image lightbox' },
    { to: '/plugins/lottie', name: 'Lottie' },
    {
      to: '/plugins',
      name: 'Map',
      children: [
        { to: '/plugins/leaflet-map', name: 'Leaflet map' },
        { to: '/plugins/google-map', name: 'Google map' },
        { to: '/plugins/echart-map', name: 'Echart Map' }
      ]
    },
    { to: '/plugins/plyr', name: 'Plyr' },
    { to: '/plugins/progressbar', name: 'Progressbar' },
    { to: '/plugins/react-hook-form', name: 'React Hook Form' },
    {
      to: '/plugins/react-bootstrap-table2',
      name: 'BS Table2'
    },
    { to: '/plugins/select', name: 'Select' },
    { to: '/plugins/slick-carousel', name: 'Slick Carousel' },
    { to: '/plugins/scroll-bar', name: 'Scroll Bar' },
    { to: '/plugins/toastify', name: 'Toastify' },
    { to: '/plugins/typed', name: 'Typed' },
    { to: '/plugins/wysiwyg', name: 'WYSIWYG editor' }
  ]
};

export const utilityRoutes = {
  name: 'Utilities',
  to: '/utilities',
  icon: ['fab', 'hotjar'],
  children: [
    { to: '/utilities/borders', name: 'Borders' },
    { to: '/utilities/clearfix', name: 'Clearfix' },
    { to: '/utilities/closeIcon', name: 'Close icon' },
    { to: '/utilities/colors', name: 'Colors' },
    { to: '/utilities/display', name: 'Display' },
    { to: '/utilities/embed', name: 'Embed' },
    { to: '/utilities/figures', name: 'Figures' },
    { to: '/utilities/flex', name: 'Flex' },
    { to: '/utilities/grid', name: 'Grid' },
    { to: '/utilities/sizing', name: 'Sizing' },
    { to: '/utilities/spacing', name: 'Spacing' },
    { to: '/utilities/stretchedLink', name: 'Stretched link' },
    { to: '/utilities/typography', name: 'Typography' },
    { to: '/utilities/verticalAlign', name: 'Vertical align' },
    { to: '/utilities/visibility', name: 'Visibility' }
  ]
};
const finalArray = [
  homeRoutes,
  pageRoutes,
  chatRoutes,
  kanbanRoutes,
  calenderRoutes,
  emailRoutes,
  authenticationRoutes,
  ECommerceRoutes,
  widgetsRoutes,
  componentRoutes,
  utilityRoutes,
  pluginRoutes,
]
export default finalArray;
